import React from "react";
import { DotLoader } from "react-spinners";
import { ConfirmActionModal } from "../../components";
import { toast } from "react-toastify";

import moment from "moment";
import selectors from "./selectors";
import actions from "../../actions";
import PropTypes from "prop-types";
import cn from "classnames";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { range } from "lodash";
import { paths } from "../../../../../common/constants";

class TripPlans extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sortTypes: {
        name: true,
        createdAt: false,
        creator: true,
        status: true,
      },
      keyword: "",
      tripToDelete: false,
      tripToSuspend: false,
      tripType: null,
      trip_plans: [],
      total: 0,
      start_at: 1,
      limit: 10,
      trip_type: "new",
      pageNumber: 1,
    };

    this.handleGetTrips = this.handleGetTrips.bind(this);
    this.toggleSortTypesState = this.toggleSortTypesState.bind(this);
    this.handleDeleteTrip = this.handleDeleteTrip.bind(this);
    this.handleSuspendTrip = this.handleSuspendTrip.bind(this);
    this.handlePagination = this.handlePagination.bind(this);

    this.openModal = this.openModal.bind(this);

    this.suspendTripModalId = "suspendTripModal";
    this.deleteTripModalId = "deleteTripModal";
  }

  componentDidMount() {
    const {
      getTripPlans,
      location: { pathname },
    } = this.props;
    const { limit } = this.state;
    const type = pathname.substring(pathname.lastIndexOf("/") + 1);

    if (type === "upcoming") {
      getTripPlans({ limit, type: "new" })
        .then(({ result: { data } }) => {
          this.setState({
            trip_plans: data.data,
            limit: data.limit,
            start_at: data.start_at,
            total: data.total,
            tripType: "new",
          });
        })
        .catch(() => {
          toast.error("Internal Server Error");
        });
    } else if (type === "past") {
      getTripPlans({ limit, type: "past" })
        .then(({ result: { data } }) => {
          this.setState({
            trip_plans: data.data,
            limit: data.limit,
            start_at: data.start_at,
            total: data.total,
            tripType: "past",
          });
        })
        .catch(() => {
          toast.error("Internal Server Error");
        });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { getTripPlans } = this.props;
    const { limit, tripType } = this.state;
    if (this.props.location.pathname !== nextProps.location.pathname) {
      const type = nextProps.location.pathname.substring(
        nextProps.location.pathname.lastIndexOf("/") + 1
      );
      if (type === "upcoming") {
        getTripPlans({ limit, type: "new" })
          .then(({ result: { data } }) => {
            this.setState({
              trip_plans: data.data,
              limit: data.limit,
              start_at: data.start_at,
              total: data.total,
              tripType: "new",
            });
          })
          .catch(() => {
            toast.error("Internal Server Error");
          });
      } else if (type === "past") {
        getTripPlans({ limit, type: "past" })
          .then(({ result: { data } }) => {
            this.setState({
              trip_plans: data.data,
              limit: data.limit,
              start_at: data.start_at,
              total: data.total,
              tripType: "past",
            });
          })
          .catch(() => {
            toast.error("Internal Server Error");
          });
      }
    }
  }

  openModal(modalToShow, trip_plan) {
    if (modalToShow === this.deleteTripModalId) {
      this.setState({ tripToDelete: trip_plan }, () => {
        $(`#${modalToShow}`).modal("show");
      });
    }
    if (modalToShow === this.suspendTripModalId) {
      this.setState({ tripToSuspend: trip_plan }, () => {
        $(`#${modalToShow}`).modal("show");
      });
    }
  }

  handleGetTrips({ target: { value } }) {
    const { getTripPlans } = this.props;
    const { limit, start_at, tripType } = this.state;

    this.setState({
      keyword: value,
    });
    if (tripType === "new")
      getTripPlans({ limit, keyword: value, start_at, type: tripType })
        .then(({ result: { data } }) => {
          this.setState({
            trip_plans: data.data,
            limit: data.limit,
            start_at: data.start_at,
            total: data.total,
            tripType: "new",
          });
        })
        .catch(() => {
          toast.error("Internal Server Error");
        });
    else if (tripType === "past")
      getTripPlans({ limit, keyword: value, start_at, type: tripType })
        .then(({ result: { data } }) => {
          this.setState({
            trip_plans: data.data,
            limit: data.limit,
            start_at: data.start_at,
            total: data.total,
            tripType: "past",
          });
        })
        .catch(() => {
          toast.error("Internal Server Error");
        });
  }

  toggleSortTypesState() {}

  handleDeleteTrip() {
    const { deleteTripPlan } = this.props;
    const { trip_plans, tripToDelete } = this.state;

    deleteTripPlan(tripToDelete._id)
      .then(() => {
        this.setState({
          trip_plans: trip_plans.filter((el) => el._id !== tripToDelete._id),
        });
        toast.success("Trip Plan was removed successfully");
      })
      .catch(({ response: { data } }) => toast.error(data.message));
  }

  handleSuspendTrip() {}

  handlePagination(query, pageNumber) {
    const { getTripPlans } = this.props;
    getTripPlans(query)
      .then(({ result: { data } }) => {
        this.setState({
          trip_plans: data.data,
          limit: data.limit,
          start_at: data.start_at,
          total: data.total,
          pageNumber: pageNumber,
        });
      })
      .catch(() => {
        toast.error("Internal Server Error");
      });
  }

  redirectToTrip(trip) {
    const {
      history: { push },
    } = this.props;
    const { tripType } = this.state;
    if (tripType === "new")
      push(paths.build(paths.client.ADMIN_TRIP_PLAN_UPCOMING_DETAIL, trip._id));
    else if (tripType === "past")
      push(paths.build(paths.client.ADMIN_TRIP_PLANS_PAST_DETAIL, trip._id));
  }

  render() {
    const { isTripPlansLoaded } = this.props;
    const {
      sortTypes,
      activeFilter,
      tripToDelete,
      tripToSuspend,
      keyword,
      trip_plans,
      total,
      limit,
      start_at,
      pageNumber,
      tripType,
    } = this.state;

    const TableContent = () => {
      return trip_plans.map((item, key) => (
        <tr key={key}>
          <td>{(pageNumber - 1) * limit + key + 1}</td>
          <td>{item.title}</td>
          <td>
            {moment(item.from_trip_date).format("MM-DD-YYYY") +
              "~" +
              moment(item.to_trip_date).format("MM-DD-YYYY")}
          </td>
          <td>{item.customerInfo.email}</td>
          <td>
            <i
              className="fa fa-pencil table-action-but"
              onClick={() => this.redirectToTrip(item)}
            >
              {" "}
              <span className="tooltiptext">Edit trip</span>{" "}
            </i>
            <i
              className="fa fa-lock table-action-but"
              onClick={() => this.openModal(this.suspendTripModalId, item)}
            >
              {" "}
              <span className="tooltiptext">Suspend trip</span>{" "}
            </i>
            <i
              className="fa fa-trash table-action-but"
              onClick={() => this.openModal(this.deleteTripModalId, item)}
            >
              {" "}
              <span className="tooltiptext">Delete trip</span>{" "}
            </i>
          </td>
        </tr>
      ));
    };

    const TablePagination = (props) => {
      const { total, limit, start_at, onPagination } = props;
      const numberOfPages = Math.ceil(total / limit) || 1;

      if (numberOfPages === 1) {
        return null;
      }

      const paginationContent = range(1, numberOfPages + 1).map(
        (pageNumber) => {
          const active = pageNumber * limit === start_at - 1;
          return (
            <div key={pageNumber} className={cn("page-item", { active })}>
              <button
                className="page-link"
                onClick={() => {
                  onPagination(
                    {
                      start_at: (pageNumber - 1) * limit + 1,
                      limit,
                      keyword: keyword.length > 0 ? keyword : null,
                    },
                    pageNumber
                  );
                }}
              >
                {pageNumber}
              </button>
            </div>
          );
        }
      );

      return (
        <div className="d-flex `table-pagination` float-right">
          {paginationContent}
        </div>
      );
    };

    const deleteTripModal = tripToDelete ? (
      <ConfirmActionModal
        id={this.deleteTripModalId}
        itemBeingDeleted={tripToDelete}
        onConfirm={this.handleDeleteTrip}
        text={`Are you sure you want to delete ${tripToDelete.title}`}
        title="Delete"
        isDeleteModal
      />
    ) : null;

    const suspendTripModal = tripToSuspend ? (
      <ConfirmActionModal
        id={this.suspendTripModalId}
        itemBeingDeleted={tripToSuspend}
        onConfirm={this.handleSuspendTrip}
        text={`Are you sure you want to suspend ${tripToSuspend.title}`}
        title="Suspend"
        isDeleteModal
      />
    ) : null;

    const content = (
      <section>
        {deleteTripModal}
        {suspendTripModal}
        <div className="row mb-4">
          <div className="col-sm-12 col-md-6 col-align-left">
            <div className="align-vertical">
              <label>Show entries</label>
              <select className="custom-select custom-select-sm form-control form-control-sm">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>
          <div className="col-sm-12 col-md-6 col-align-right">
            <div className="align-vertical">
              <label>Search</label>
              <input
                type="search"
                className="form-control form-control-sm search-input-box"
                placeholder="Search"
                value={keyword}
                onChange={this.handleGetTrips}
              ></input>
            </div>
          </div>
        </div>
        <div className="row mb-4">
          <div className="col">
            <div id="posts">
              <table
                className="table table-striped table-bordered table-sm"
                cellSpacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th className="th-sm">
                      <div className="d-flex">
                        <div className="th-title">No</div>
                        <i
                          className={cn("fa ml-2 fa-caret-up", {
                            isActive:
                              sortTypes[activeFilter] && activeFilter === "no",
                          })}
                        />
                        <i
                          className={cn("fa ml-2 fa-caret-down", {
                            isActive:
                              !sortTypes[activeFilter] && activeFilter === "no",
                          })}
                        />
                      </div>
                    </th>
                    <th className="th-sm">
                      <div className="d-flex">
                        <div className="th-title">Title</div>
                        <i
                          className={cn("fa ml-2 fa-caret-up", {
                            isActive:
                              sortTypes[activeFilter] &&
                              activeFilter === "name",
                          })}
                        />
                        <i
                          className={cn("fa ml-2 fa-caret-down", {
                            isActive:
                              !sortTypes[activeFilter] &&
                              activeFilter === "name",
                          })}
                        />
                      </div>
                    </th>
                    <th className="th-sm">
                      <div className="d-flex">
                        <div className="th-title">Trip Date</div>
                        <i
                          className={cn("fa ml-2 fa-caret-up", {
                            isActive:
                              sortTypes[activeFilter] &&
                              activeFilter === "email",
                          })}
                        />
                        <i
                          className={cn("fa ml-2 fa-caret-down", {
                            isActive:
                              !sortTypes[activeFilter] &&
                              activeFilter === "email",
                          })}
                        />
                      </div>
                    </th>
                    <th className="th-sm">
                      <div className="d-flex">
                        <div className="th-title">Trip By</div>
                        <i
                          className={cn("fa ml-2 fa-caret-up", {
                            isActive:
                              sortTypes[activeFilter] &&
                              activeFilter === "posts_count",
                          })}
                        />
                        <i
                          className={cn("fa ml-2 fa-caret-down", {
                            isActive:
                              !sortTypes[activeFilter] &&
                              activeFilter === "posts_count",
                          })}
                        />
                      </div>
                    </th>
                    <th className="th-sm">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <TableContent />
                </tbody>
              </table>
              <TablePagination
                total={total}
                limit={limit}
                start_at={start_at}
                onPagination={this.handlePagination}
              />
              {!isTripPlansLoaded ? (
                <div className="spinner-container">
                  <DotLoader sizeUnit={"px"} size={50} color={"#00DD8C"} />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </section>
    );

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">{content}</div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

TripPlans.propTypes = {
  isTripPlansLoaded: PropTypes.bool.isRequired,
  getTripPlans: PropTypes.func.isRequired,
  deleteTripPlan: PropTypes.func.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

export default connect(selectors, {
  ...actions.trip_plans,
})(withRouter(TripPlans));



// WEBPACK FOOTER //
// ./client/react/Admin/views/TripPlans/index.js